import React from "react";
import PropTypes from "prop-types";
import { ParseContextMenuItems } from "./form-automation-util";
import FluentUiIcon from "../../../../../../../assets/fluent-ui-icon";
import { FluentTooltip } from "../../../../../../../components/FluentUI/Fluent-Tooltip";
import { FluentMenu } from "../../../../../../../components/FluentUI/Fluent-Menu";

export const ViewFormsItem = ({ setFormId, setFormName, form }) => {
  const ContextMenuClick = (e, identifier) => {
    e.stopPropagation();
    switch (identifier) {
      case "Edit":
        setFormId(form.Id);
        setFormName(form.Label);
        break;
      default:
        break;
    }
  };

  const OnEditForm = (e) => {
    if (!(e.target instanceof SVGElement)) {
      setFormId(form.Id);
      setFormName(form.Label);
    }
  };

  return (
    <div className="view-forms-list-content-item">
      <div className="view-forms-list-content-item-icon">
        <FluentUiIcon name={"FormRegular"} color={"#0F6CBD"} size={20} />
      </div>
      <div className="view-forms-list-content-item-info" onClick={OnEditForm}>
        <FluentTooltip
          target={
            <div className="view-forms-list-content-item-info-name">
              {form.Label}
            </div>
          }
          text={form.Label}
        ></FluentTooltip>
      </div>
      <FluentMenu
        button={
          <FluentUiIcon
            name={"MoreHorizontalRegular"}
            color={"#212121"}
            size={20}
          ></FluentUiIcon>
        }
        items={ParseContextMenuItems(ContextMenuClick)}
      ></FluentMenu>
    </div>
  );
};

ViewFormsItem.propTypes = {
  setFormId: PropTypes.func,
  form: PropTypes.object,
};